import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-curriculum-create',
  templateUrl: './curriculum-create.component.html',
  styleUrls: ['./curriculum-create.component.scss']
})
export class CurriculumCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  coursename = null;
  submitted = false;
  public curriculumForm: FormGroup;
  public courses = [];

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/curriculumbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.curriculumForm.patchValue({
              _id: data.data._id,
              course: data.data.course,
              coursename: data.data.coursename,
              year: data.data.year,
              semister1: data.data.semister1,
              semister2: data.data.semister2,
              // subject: data.data.subject,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.http.get<any>(this.api_endpoint+'/courses/').subscribe(
        data => {
          this.courses = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });

    this.curriculumForm = this.formBuilder.group({
      course: ['', Validators.required],
      year: ['', Validators.required],
      semister1: ['', Validators.required],
      semister2: ['', Validators.required],
      // subject: ['', Validators.required],
      coursename: [''],
      _id: ['']
    })
  }

  getcourses(value){
    this.http.get<any>(this.api_endpoint+'/coursebyid/'+value).subscribe(
      data => {
        
        this.curriculumForm.patchValue({
          coursename: data.data.course,
        })
       
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  get f() { return this.curriculumForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.curriculumForm.invalid) {
      return;
    }

    
      // console.log(this.coursename);
    if(this.action == 'Submit'){

      

    var data = {
      "course" : this.curriculumForm.value.course,
      "coursename" : this.curriculumForm.value.coursename,
      "year" : this.curriculumForm.value.year,
      "semister1" : this.curriculumForm.value.semister1,
      "semister2" : this.curriculumForm.value.semister2,
      "admin" : sessionStorage.getItem('adminName'),
      // "subject" : this.curriculumForm.value.subject,
    };
    console.log(data);
    
    this.http.post<any>(this.api_endpoint+'/curriculum', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/curriculum/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
    }else{
      var data1 = {
        "course" : this.curriculumForm.value.course,
        "coursename" : this.curriculumForm.value.coursename,
        "year" : this.curriculumForm.value.year,
        "semister1" : this.curriculumForm.value.semister1,
        "semister2" : this.curriculumForm.value.semister2,
        "admin" : sessionStorage.getItem('adminName'),
        // "subject" : this.curriculumForm.value.subject,
        "_id" : this.curriculumForm.value._id,
      };
        // console.log(data1);     
        this.http.put<any>(this.api_endpoint+'/curriculum/', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/curriculum/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    }
  }

}
